import type { Provenance } from '@fishstank/contracts'

interface Props {
  provenance: Provenance | null
}

export function ProvenanceFooter({ provenance }: Props) {
  if (!provenance) {
    return (
      <footer
        className="border-t border-slate-800 bg-fishstank-ink/80"
        data-testid="provenance-footer"
      >
        <div className="mx-auto max-w-screen-2xl px-4 py-2 text-xs text-slate-500">
          No provenance yet.
        </div>
      </footer>
    )
  }
  return (
    <footer
      className="border-t border-slate-800 bg-fishstank-ink/80"
      data-testid="provenance-footer"
    >
      <div className="mx-auto max-w-screen-2xl px-4 py-2 text-xs text-slate-500 font-mono">
        <span>
          deployment:{' '}
          <span data-testid="deployment-id" className="text-slate-300">
            {provenance.deployment_id}
          </span>
        </span>
        <span className="mx-2 text-slate-700">·</span>
        <span>
          written_at:{' '}
          <span className="text-slate-300">{provenance.written_at}</span>
        </span>
        <span className="mx-2 text-slate-700">·</span>
        <span>
          schema:{' '}
          <span className="text-slate-300">v{provenance.schema_version}</span>
        </span>
      </div>
    </footer>
  )
}
